import React, { useState } from "react";
import { motion } from "framer-motion";
import {
  EnvelopeIcon,
  XMarkIcon,
  BuildingOfficeIcon,
} from "@heroicons/react/24/outline";
import Button from "../components/ui/Button";
import Card from "../components/ui/Card";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogClose,
} from "../components/ui/Dialog";
import Badge from "../components/ui/Badge";
import Separator from "../components/ui/Separator";
import ContactForm from "../components/relators/ContactForm";

const RealtorPage = () => {
  const [selectedRealtor, setSelectedRealtor] = useState(null);

  const blerk = "so ";
  const d = "ts ";

  const kevin = "bad";

  console.log(d + blerk + kevin);

  const realtors = [
    {
      name: "Armin Partash",
      title: "Sales Representative, Realtor",
      email: "armin.partash@century21.ca",
      image: require("../assets/armin.png"),
      specialties: ["Preconstruction", "Residental and Condos", "Investment"],
      experience: "15+ Years of real estate experience",
      blurb: `Armin Partash is a sales representative at Century 21 Atria Realty. He is a dedicated realtor who is passionate about helping his clients find their dream home. Armin is fluent in English and Persian.`,
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-[#444444] mb-4">
            Meet Our Realtor
          </h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Our team of experienced professionals is dedicated to providing
            exceptional service and expertise in every real estate transaction.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {realtors.map((realtor, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}>
              <Card
                className="overflow-hidden hover:shadow-lg transition-all duration-300 cursor-pointer group"
                onClick={() => setSelectedRealtor(realtor)}>
                <div className="relative">
                  <div className="aspect-[4/5] overflow-hidden">
                    <img
                      src={realtor.image}
                      alt={realtor.name}
                      className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
                    <p className="text-white text-sm">Click to view profile</p>
                  </div>
                </div>
                <div className="p-6">
                  <h2 className="text-xl font-semibold text-[#444444] mb-2">
                    {realtor.name}
                  </h2>
                  <p className="text-gray-600 text-sm mb-4">{realtor.title}</p>
                  <div className="flex flex-wrap gap-2">
                    {realtor.specialties.map((specialty, i) => (
                      <Badge key={i} variant="secondary" className="text-xs">
                        {specialty}
                      </Badge>
                    ))}
                  </div>
                </div>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>

      <Dialog
        open={!!selectedRealtor}
        onOpenChange={() => setSelectedRealtor(null)}>
        <DialogContent className="sm:max-w-3xl p-6">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-2xl">
              {selectedRealtor?.name}
            </DialogTitle>
            <DialogDescription className="text-gray-600">
              {selectedRealtor?.title}
            </DialogDescription>
          </DialogHeader>

          <div className="grid grid-cols-1 md:grid-cols-[300px,1fr] gap-6">
            <div>
              <div className="overflow-hidden mb-4">
                <img
                  src={selectedRealtor?.image}
                  alt={selectedRealtor?.name}
                  className="w-full h-auto"
                />
              </div>
              <div className="space-y-4">
                <div className="flex items-center gap-2">
                  <EnvelopeIcon className="w-5 h-5 text-gray-500" />
                  <a
                    href={`mailto:${selectedRealtor?.email}`}
                    className="text-blue-600 hover:underline">
                    {selectedRealtor?.email}
                  </a>
                </div>
                <div className="flex items-center gap-2">
                  <BuildingOfficeIcon className="w-5 h-5 text-gray-500" />
                  <span className="text-gray-600">
                    {selectedRealtor?.experience}
                  </span>
                </div>
                <div className="flex flex-wrap gap-2">
                  {selectedRealtor?.specialties.map((specialty, i) => (
                    <Badge key={i} variant="outline">
                      {specialty}
                    </Badge>
                  ))}
                </div>
              </div>
            </div>

            <div className="space-y-4">
              {selectedRealtor?.blurb.split("\n\n").map((paragraph, i) => (
                <p key={i} className="text-gray-600">
                  {paragraph}
                </p>
              ))}
            </div>
          </div>

          <Separator className="my-6" />

          <div className="px-6 pb-6">
            <h3 className="text-lg font-semibold text-[#444444] mb-4 text-center">
              Get in Touch with {selectedRealtor?.name}
            </h3>
            <ContactForm
              realtor={selectedRealtor}
              closeModal={() => setSelectedRealtor(null)}
            />
          </div>

          <div className="mt-6 flex justify-end">
            <DialogClose asChild>
              <Button
                variant="ghost"
                onClick={() => setSelectedRealtor(null)}
                className="flex items-center">
                <XMarkIcon className="h-5 w-5" />
              </Button>
            </DialogClose>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default RealtorPage;
